<template>
  <div id="LandingConfirmAccount" class="row">
    <div class="overlay"></div>

    <div class="modal UpdateModel">
      <span class="ConfirmAccount">{{ $t("ConfirmAccount") }}</span>
      <div class="group">
        <b>{{ $t("PleaseRegister") }}</b>
        <input type="text" class="input" v-model="user.phone" disabled />
      </div>
      <div class="group mt-3">
        <b>{{ $t("FullName") }}</b>
        <input
          type="text"
          id="fullname"
          v-model="user.fullname"
          :placeholder="$t('FullName')"
          minlength="3"
        />
      </div>
      <div class="text-danger mt-3 ml-1" v-if="checkName">
        {{ $t("ErrorCheck") }}
      </div>
      <div class="group mt-3">
        <b>{{ $t("Email") }}</b>
        <input
          type="email"
          id="email"
          v-model="user.email"
          placeholder="Email"
        />
      </div>
      <div class="text-danger mt-3 ml-1" v-if="checkEmail">
        {{ $t("ErrorCheck") }}
      </div>
      <div class="group mt-3" v-if="Config.enable_social_reason">
        <b>{{ $t("SocialReason") }}</b>
        <input
          type="tel"
          id="login"
          v-model="user.social_reason"
          :placeholder="$t('SocialReason')"
        />
      </div>
      <div id="termsNcond" class="d-flex justify-content-center mt-4">
        <vs-checkbox
          :id="'terms'"
          :vs-value="true"
          v-model="terms"
        >
          {{ $t("AcceptTermsUrl") }}
        </vs-checkbox>
        <span @click="showPopupTerms" style="text-decoration: underline; color: var(--primary); cursor: pointer;">{{ $t("TermsUrl") }}</span>
      </div>
      <div class="text-danger mt-3 ml-1" v-if="checkTerms">
          {{ $t("ErrorCheck") }}
        </div>

      <div class="footer">
        <button class="btn" @click="editProfile()" v-if="!loading">
          {{ $t("Modify") }}
        </button>
        <button class="btn" v-else>
          <font-awesome-icon class="icon spin-icon" icon="spinner" />
        </button>
      </div>
      <div class="text-danger text-center mt-3" v-if="error_edit">
        {{ $t("InformationUpdateError") }}
      </div>
    </div>
    <PopupTerms
        :active="popupTerms.active"
        :type="popupTerms.type"
        :title="popupTerms.title"
        :message="popupTerms.message"
        :confirmationButton="popupTerms.confirmationButton"
        @closePopupTerms="closePopupTerms"
      />
  </div>
</template>

<script>
import $ from "jquery";
import { userService } from "/src/_services";
import PopupTerms from "../modals/PopupTerms.vue"

export default {
  data: () => ({
    lang: localStorage.getItem("Language"),
    loading: false,
    terms: false,
    error_edit: false,
    checkTerms: false,
    checkName: false,
    checkEmail: false,
    popupTerms: {
      active: false,
      type: "terms",
      title: "",
      message: "",
      confirmationButton: "",
    }
  }),
  props: {
    user: Object,
  },
  components: {
    PopupTerms
  },
  mounted() {
    if (this.lang == "ar") {
      document.getElementById("termsNcond").dir = "rtl";
    }
  },
  methods: {
    closePopupTerms() {
      this.popupTerms.active = false;
    },
    showPopupTerms() {
      this.popupTerms.confirmationButton = this.$t('Company.Close');
      $("#PreLoader").show();
      userService.getTerms(this.Config.organization_id).then(function(res) {
        this.popupTerms.message = res.terms.content;
        this.popupTerms.active = true;
      }.bind(this)).catch(function() {
        this.popupTerms.message = this.$t('ErrorOccured');
        this.popupTerms.active = true;
      }.bind(this)).finally(function() {
        $("#PreLoader").hide();
      }.bind(this))
    },
    editProfile() {
      if (this.terms) {
        this.error_edit = false;
        let data = new FormData();

        data.append("fullname", this.user.fullname);
        data.append("email", this.user.email);
        data.append(
          "social_reason",
          this.user.social_reason ? this.user.social_reason : ""
        );
        data.append("_method", "PUT");

        if (this.user.fullname.length <= 1) {
          this.checkName = true;
          return;
        } else {
          this.checkName = false;
        }
        if (!this.user.email) {
          this.checkEmail = true;
          return;
        } else {
          this.checkEmail = false;
        }
        this.loading = true;
        userService
          .update(data)
          .then(
            function (data) {
              let actualUser = JSON.parse(localStorage.getItem("user"));
              actualUser.fullname = data.user.fullname;
              actualUser.email = data.user.email;
              actualUser.social_reason = data.user.social_reason;
              localStorage.setItem("user", JSON.stringify(actualUser));
              this.user = actualUser;
              $("#code1").focus();
              setTimeout(function () {
                $("#code1").focus();
              }, 300);
            }.bind(this)
          )
          .catch(
            function () {
              this.error_edit = true;
            }.bind(this)
          )
          .finally(
            function () {
              this.loading = false;
              location.replace("/");
            }.bind(this)
          );
      } else {
        this.checkTerms = true;
      }
    },
    show() {
      $("#LandingConfirmAccount").fadeIn("300");
    },
    hide() {
      $("#LandingConfirmAccount").fadeOut("300", function () {
        $(".UpdateModel").fadeIn();
        $(".RegisterModal").fadeOut();
        $(".VerifyModal").fadeOut();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ConfirmAccount {
  font-size: 18px;
  font-weight: 900;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
#LandingConfirmAccount {
  width: 100vw;
  height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: absolute;
  top: 50%;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999990;

  display: none;
  .overlay {
    width: 100vw;
    height: 100vh;
    min-height: -webkit-fill-available;
    z-index: 9999999999991;
    cursor: pointer;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .modal {
    width: 40%;
    height: auto;
    min-width: 320px;
    background: #fff;
    z-index: 992;
    border-radius: 25px;
    padding: 50px;

    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .Verify {
      margin-top: 20px;
      .code {
        display: flex;
        justify-content: center;
        input {
          margin-left: 10px;
          margin-right: 10px;
          height: 50px;
          width: 50px;
          border: 1px solid var(--primary);
          color: var(--primary);
          border-radius: 5px;
          text-align: center;
          font-size: 15px;
        }
      }
    }
    .group {
      b {
        color: var(--primary);
        font-size: 16px;
        font-size: 900;
        margin-bottom: 10px;
        display: block;
      }
      input {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
    .footer {
      text-align: center;
      margin-top: 20px;
      .text {
        color: #555;
        font-size: 14px;
      }
      button {
        background: var(--primary);
        color: var(--primary-font);
        padding: 15px 50px;
        border-radius: 100px;
        letter-spacing: 1px;
        margin-top: 20px;
        font-size: 15px;
      }
      button:hover {
        background: var(--primary-hover);
      }
    }
  }
  .RegisterModal {
    display: none;
  }
  @media only screen and (max-width: 800px) {
    .modal {
      .Verify {
        .code {
          input {
            width: 40px;
            height: 40px;
            margin-left: 5px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>